import { useQuery, keepPreviousData } from "@tanstack/react-query";

import { api } from "@/lib/api";
import type { ArticleRow, Paginated, WorkflowState } from "@/lib/types";

interface ArticlesQuery {
  search?: string;
  scope?: "my" | "all";
  status?: WorkflowState;
  page?: number;
  ordering?: string;
}

/** GET /api/v1/articles/ — same shape as useDocuments. */
export function useArticles(q: ArticlesQuery = {}) {
  return useQuery<Paginated<ArticleRow>>({
    queryKey: ["articles", q],
    placeholderData: keepPreviousData,
    queryFn: async () => {
      const params = new URLSearchParams();
      if (q.search)        params.set("search",   q.search);
      if (q.scope === "my") params.set("scope",   "my");
      if (q.status)        params.set("status",   q.status);
      if (q.page)          params.set("page",     String(q.page));
      if (q.ordering)      params.set("ordering", q.ordering);
      const { data } = await api.get<Paginated<ArticleRow>>(
        `/articles/?${params.toString()}`,
      );
      return data;
    },
  });
}
